<template>
  <section class="container mx-auto px-4 py-20">
    <div class="flex flex-col items-center text-center" v-scroll-reveal="{ delay: 0.1 }">
      <p class="text-sm uppercase tracking-[0.6em] text-amber-500">Haramain Ziarat</p>
      <h2 class="mt-4 text-4xl font-bold text-gray-900 lg:text-5xl">
        Visit the Sacred Sites of Makkah &amp; Madina
      </h2>
      <p class="mt-4 max-w-3xl text-gray-600">
        Guided Ziarat tours to the historical and spiritual landmarks connected to the life of the Prophet (peace be upon him),
        led by knowledgeable local guides.
      </p>
    </div>

    <div class="mt-12 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
      <article
        v-for="(tour, index) in ziaratTours"
        :key="tour.title"
        class="relative flex h-[520px] flex-col overflow-hidden rounded-[32px] border border-gray-100 bg-white shadow-lg transition hover:-translate-y-2"
        v-scroll-reveal="{ delay: index * 0.15 }"
      >
        <!-- Image: Fixed height -->
        <div class="h-56 flex-shrink-0 overflow-hidden">
          <img :src="tour.image" :alt="tour.title" class="h-full w-full object-cover transition duration-500 hover:scale-105" />
        </div>

        <!-- Content: Flex column -->
        <div class="flex flex-1 flex-col px-6 py-6">
          <!-- Category: Separate line -->
          <div class="flex-shrink-0">
            <span class="text-xs font-semibold uppercase tracking-[0.4em] text-gray-500">{{ tour.category.toUpperCase() }}</span>
          </div>

          <!-- Price: Separate line -->
          <div class="mt-1 flex-shrink-0">
            <span class="text-xs font-semibold text-amber-500">{{ tour.price }}</span>
          </div>

          <!-- Title: Fixed height with line clamp -->
          <h3 class="mt-3 flex-shrink-0 text-2xl font-semibold text-gray-900 line-clamp-2 min-h-[3.5rem]">{{ tour.title }}</h3>

          <!-- Description: Fixed height with truncation -->
          <div class="mt-3 flex-1 flex items-start">
            <p class="text-sm text-gray-600 leading-relaxed line-clamp-3">{{ truncateText(tour.description, 100) }}</p>
          </div>

          <!-- Footer: Duration and CTA - Sticky at bottom -->
          <div class="mt-6 flex-shrink-0 flex items-center justify-between text-sm font-semibold text-amber-600">
            <span>{{ tour.duration }}</span>
            <router-link
              to="/contact"
              class="inline-flex items-center gap-2 transition hover:text-amber-700"
            >
              Book Ziarat
              <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </router-link>
          </div>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
// Haramain Ziarat Images
import localTour1 from '../../assets/images/localTour-1.jpg'
import madinaZiarat from '../../assets/images/madina/madina-aerial-night.jpg'
import localTour3 from '../../assets/images/localTour-3.jpg'
import localTour4 from '../../assets/images/localTour-4.jpg'
import { listItems } from '../../services/dataStore'

export default {
  name: 'ToursSection',
  async mounted() {
    this.ziaratTours = await listItems('ziaratTours', this.ziaratTours)
  },
  data() {
    return {
      ziaratTours: [
        {
          title: 'Makkah Ziarat Tour',
          category: 'Makkah',
          price: 'Rs 8,500 / PERSON',
          duration: 'Half Day',
          description: 'Visit Jabal al-Nour, the Cave of Hira, Jabal Thawr, Mina, Arafat, Muzdalifah, and the Museum of the Two Holy Mosques.',
          image: localTour1
        },
        {
          title: 'Madina Ziarat Tour',
          category: 'Madina',
          price: 'Rs 7,500 / PERSON',
          duration: 'Half Day',
          description: 'Explore Quba Mosque, Qiblatain Mosque, Mount Uhud and the Martyrs\' Cemetery, and Jannat al-Baqi with a knowledgeable guide.',
          image: madinaZiarat
        },
        {
          title: 'Badr Historical Tour',
          category: 'Historical',
          price: 'Rs 12,000 / PERSON',
          duration: 'Full Day',
          description: 'A day trip from Madina to the historic site of the Battle of Badr, one of the most significant events in Islamic history.',
          image: localTour3
        },
        {
          title: 'Taif Ziarat & Nature Trip',
          category: 'Taif',
          price: 'Rs 9,500 / PERSON',
          duration: 'Full Day',
          description: 'Scenic drive to Taif, visiting sites connected to the Prophet\'s (peace be upon him) journey, along with the rose gardens and cool mountain air.',
          image: localTour4
        }
      ]
    }
  },
  methods: {
    truncateText(text, maxLength) {
      if (text.length <= maxLength) {
        return text
      }
      return text.substring(0, maxLength) + '...'
    }
  }
}
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
